// extracted by mini-css-extract-plugin
export default {"extraFields":"PageCatalogConfig_extraFields__w2Hnm"};